import { NavLink } from "react-router-dom";

import { Button } from "@icg360/design-system";

import styles from "./public-header.module.scss";

export const PublicHeaderNav = () => {
  return (
    <nav className={styles.nav}>
      <NavLink className={styles.link} to="/payment">
        Make a payment
      </NavLink>
      <NavLink className={styles.link} to="/contact-us">
        Contact us
      </NavLink>
      <a className={styles.loginBtn} href="/auth/login">
        <Button>Log in</Button>
      </a>
    </nav>
  );
};
